<mat-card appearance="outlined">
  <mat-card-header>
    <h4 mat-card-title>Inloggen</h4>
  </mat-card-header>
  <mat-card-content>
    @if (!loading) {
      <form (submit)="signIn()">
        <mat-form-field>
          <input
            matInput
            placeholder="E-mailadres"
            [(ngModel)]="email"
            required
            name="email"
            />
          </mat-form-field>
          <mat-form-field>
            <input
              matInput
              type="password"
              placeholder="Wachtwoord"
              [(ngModel)]="password"
              required
              name="password"
              />
            </mat-form-field>
            <mat-checkbox name="rememberme" [(ngModel)]="rememberMe"
              >Onthoud mijn e-mailadres</mat-checkbox
              ><br />
              <mat-action-row>
                <div fxLayout fxLayoutAlign="end">
                  <button
                    type="submit"
                    color="primary"
                    align="end"
                    mat-raised-button
                    [disabled]="loading"
                    >
                    Log in
                  </button>
                </div>
              </mat-action-row>
            </form>
          }
          <mat-action-row>
            <button mat-raised-button (click)="openDialog(forgotPasswordDialog)"
              >Wachtwoord vergeten?</button
              ><br />
            </mat-action-row>
            @if (loading) {
              <app-spinner></app-spinner>
            }
          </mat-card-content>
        </mat-card>

        <ng-template #forgotPasswordDialog>
          <h4 mat-dialog-title>Wachtwoord vergeten</h4>
          <mat-dialog-content>
            <p>
              Vul je e-mailadres is en je krijgt een mailtje waarmee je een nieuw
              wachtwoord in kunt stellen.
            </p>
            @if (dialogErrorMessage) {
              <div class="alert alert-danger" role="alert">
                <p>{{ dialogErrorMessage }}</p>
              </div>
            }
            @if (dialogSuccessMessage) {
              <div class="alert alert-success" role="alert">
                <p>{{ dialogSuccessMessage }}</p>
              </div>
            }

            <mat-form-field class="example-full-width">
              <input
                type="text"
                matInput
                placeholder="E-mailadres"
                id="dialogEmail"
                name="dialogEmail"
                [(ngModel)]="dialogEmail"
                />
              </mat-form-field>

              <div align="end">
                <button mat-button color="secondary" (click)="dialogRef.close()">
                  Annuleren
                </button>
                <button mat-raised-button color="primary" (click)="postForgotPassword()">
                  Verstuur
                </button>
              </div>
            </mat-dialog-content>
          </ng-template>

          <ng-template #cookieLawDialog>
            <h4 mat-dialog-title>Cookies</h4>
            <mat-dialog-content>
              <p>
                Deze website gebruikt cookies. Door verder te gaan accepteert je dit. Wij
                verstrekken verder geen informatie over jou aan derden hoor.
              </p>
              <div align="end">
                <button
                  mat-raised-button
                  color="primary"
                  (click)="acceptCookies()"
                  mat-dialog-close
                  >
                  Oké
                </button>
              </div>
            </mat-dialog-content>
          </ng-template>
